
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $iZbq8 = parcelRequire("iZbq8");
(0, $iZbq8.startNextButton).addEventListener("click", $d7288e569b3d5aed$var$nextTurn);
(0, $iZbq8.pauseButton).addEventListener("click", $d7288e569b3d5aed$var$pauseGame);
(0, $iZbq8.resetButton).addEventListener("click", $d7288e569b3d5aed$var$stopGame);
let $d7288e569b3d5aed$var$activePlayer = null;
let $d7288e569b3d5aed$var$playing = false;
let $d7288e569b3d5aed$var$playerTimers = null;
let $d7288e569b3d5aed$var$timerIntervalId = null;
/**
 * Next turn at game.
 * @param {Event} event 
 */ function $d7288e569b3d5aed$var$nextTurn(event) {
    if (!$d7288e569b3d5aed$var$playing) {
        (0, $iZbq8.pauseButton).textContent = "Pausen";
        $d7288e569b3d5aed$var$playing = true;
    }
    if ($d7288e569b3d5aed$var$activePlayer != null) {
        (0, $iZbq8.playersListItems)[$d7288e569b3d5aed$var$activePlayer].removeAttribute("active");
        $d7288e569b3d5aed$var$activePlayer = ($d7288e569b3d5aed$var$activePlayer + 1) % (0, $iZbq8.playersListItems).length;
    }
    if ($d7288e569b3d5aed$var$activePlayer == null && (0, $iZbq8.playersListItems).length > 1) {
        $d7288e569b3d5aed$var$activePlayer = 0;
        (0, $iZbq8.startNextButton).textContent = "Seg\xfcent";
        $d7288e569b3d5aed$var$playing = true;
        $d7288e569b3d5aed$var$playerTimers = new Array((0, $iZbq8.playersListItems).length).fill(0);
    }
    (0, $iZbq8.playersListItems)[$d7288e569b3d5aed$var$activePlayer].setAttribute("active", "");
    if ((0, $iZbq8.accumulateCheckbox).checked) $d7288e569b3d5aed$var$playerTimers[$d7288e569b3d5aed$var$activePlayer] += Number((0, $iZbq8.turnTimeInput).value) + 1 //+ playerTimers[activePlayer];
    ;
    $d7288e569b3d5aed$var$playSound(440, 1);
    window.clearInterval($d7288e569b3d5aed$var$timerIntervalId);
    $d7288e569b3d5aed$var$timerIntervalId = window.setInterval($d7288e569b3d5aed$var$timerFunction, 1000);
    $d7288e569b3d5aed$var$timerFunction();
}
function $d7288e569b3d5aed$var$stopGame() {
    window.clearInterval($d7288e569b3d5aed$var$timerIntervalId);
    $d7288e569b3d5aed$var$activePlayer = null;
    $d7288e569b3d5aed$var$playing = false;
    $d7288e569b3d5aed$var$playerTimers = null;
    (0, $iZbq8.playersListItems).forEach((listItem)=>{
        listItem.querySelector(".timer").textContent = "00:00";
        listItem.removeAttribute("active");
    });
    (0, $iZbq8.startNextButton).textContent = "Inicia";
    (0, $iZbq8.pauseButton).textContent = "Pausen";
}
function $d7288e569b3d5aed$var$pauseGame() {
    if ($d7288e569b3d5aed$var$activePlayer == null) return;
    if ($d7288e569b3d5aed$var$playing) {
        window.clearInterval($d7288e569b3d5aed$var$timerIntervalId);
        (0, $iZbq8.pauseButton).textContent = "Continuen";
    } else {
        $d7288e569b3d5aed$var$timerIntervalId = window.setInterval($d7288e569b3d5aed$var$timerFunction, 1000);
        (0, $iZbq8.pauseButton).textContent = "Pausen";
    }
    $d7288e569b3d5aed$var$playing = !$d7288e569b3d5aed$var$playing;
}
function $d7288e569b3d5aed$var$timerFunction() {
    let seconds = $d7288e569b3d5aed$var$playerTimers[$d7288e569b3d5aed$var$activePlayer];
    if (seconds <= 0) {
        $d7288e569b3d5aed$var$nextTurn();
        return;
    }
    if (seconds <= 10) $d7288e569b3d5aed$var$playSound();
    (0, $iZbq8.playersListItems)[$d7288e569b3d5aed$var$activePlayer].querySelector(".timer").textContent = `${Math.floor(--seconds / 60).toString().padStart(2, "0")}:${(seconds % 60).toString().padStart(2, "0")}`;
    $d7288e569b3d5aed$var$playerTimers[$d7288e569b3d5aed$var$activePlayer] = seconds;
}
/**
 * 
 * @param {Number} frequency 
 * @param {Number} duration 
 * @param {String} type Can be 'sine', 'square', 'sawtooth', 'triangle'.
 */ function $d7288e569b3d5aed$var$playSound(frequency = 440, duration = 0.5, type = "sine") {
    const audioContext = new AudioContext();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    oscillator.type = type;
    oscillator.frequency.value = frequency;
    oscillator.start();
    gainNode.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + duration);
    oscillator.stop(audioContext.currentTime + duration);
}
(0, $iZbq8.deleteAllButton).addEventListener("click", $d7288e569b3d5aed$var$stopGame);


//# sourceMappingURL=rummiclock.60e9e84c.js.map
